module.exports = __webpack_public_path__ + "img/centivo-care-logo.66f8e3e4.svg";